//#region src/location_multi_payment_support.ts
var LocationMultiPaymentSupport = /* @__PURE__ */ function(LocationMultiPaymentSupport) {
	LocationMultiPaymentSupport["Disabled"] = "disabled";
	LocationMultiPaymentSupport["Enabled"] = "enabled";
	return LocationMultiPaymentSupport;
}(LocationMultiPaymentSupport || {});
//#endregion
export { LocationMultiPaymentSupport };

//# sourceMappingURL=location_multi_payment_support.js.map